module.exports = __webpack_public_path__ + "img/97ne.4e9b614d.svg";